module.exports = __webpack_public_path__ + "img/hot_profile.77cfab81.png";